import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/asesmen-awal-ranap-perinatal", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/asesmen-awal-ranap-perinatal/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asesmen-awal-ranap-perinatal`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/asesmen-awal-ranap-perinatal/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/asesmen-awal-ranap-perinatal/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function verifyByDpjp(id: number, data) {
  const response = await http
    .postData(`/asesmen-awal-ranap-perinatal/${id}/verify-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function verifyByPpja(id: number, data) {
  const response = await http
    .postData(`/asesmen-awal-ranap-perinatal/${id}/verify-ppja`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function print(id) {
  window.open(
    `${http.getAPI()}/asesmen-awal-ranap-perinatal/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  verifyByDpjp,
  verifyByPpja,
  print
};
